<h1 mat-dialog-title>{{ data.header }}</h1>
<div mat-dialog-content>
  <p [innerHTML]="data.text | safeHtml"></p>
  @if (keys?.length < 1) {
    <pre>{{ data.properties }}</pre>
  }
  @if (keys && keys.length > 0) {
    <table>
      @for (k of keys; track k) {
        <tr>
          <td>{{ formatKey(k) | titlecase }}</td>
          <td>
            @if (clip || valueForKey(k).length < 200) {
              <div class="clipped">
                {{ valueForKey(k) }}
              </div>
            } @else {
              <pre> {{ data.properties[k] | json }}</pre>
            }
            @if (valueForKey(k).length > 200) {
              <a (click)="clip = !clip">{{ clip ? 'more...' : 'less...' }}</a>
            }
          </td>
        </tr>
      }
    </table>
  }
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close autofocus>Ok</button>
</div>
